import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getOrderData as _getOrderData, getOrderList as _getOrderList } from "@api/order";
import { cancelOrderHandle, payOrderHandle, takeOrderHandle } from "@libs/order";
import Loading from "@components/Loading";
import Payment from "@components/Payment";
import { mapGetters } from "vuex";
import { isWeixin } from "@utils";
import GeneralWindow from "@components/GeneralWindow";
var STATUS = ["待付款", "待发货", "待收货", "待评价", "已完成", "", "", "", "", "待付款"];
var NAME = "MyOrder";
export default {
  name: NAME,
  data: function data() {
    return {
      offlinePayStatus: 2,
      orderData: {},
      type: parseInt(this.$route.params.type) || 0,
      page: 1,
      limit: 20,
      loaded: false,
      loading: false,
      orderList: [],
      pay: false,
      payType: ["yue", "weixin"],
      from: isWeixin() ? "weixin" : "weixinh5",
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      }
    };
  },
  components: {
    Loading: Loading,
    Payment: Payment,
    GeneralWindow: GeneralWindow
  },
  computed: mapGetters(["userInfo"]),
  watch: {
    $route: function $route(n) {
      if (n.name === NAME) {
        var type = parseInt(this.$route.params.type) || 0;

        if (this.type !== type) {
          this.changeType(type);
        }

        this.getOrderData();
      }
    }
  },
  methods: {
    setOfflinePayStatus: function setOfflinePayStatus(status) {
      var that = this;
      that.offlinePayStatus = status;

      if (status === 1) {
        if (that.payType.indexOf("offline") < 0) {
          that.payType.push("offline");
        }
      }
    },
    getOrderData: function getOrderData() {
      var _this = this;

      _getOrderData().then(function (res) {
        _this.orderData = res.data;
      });
    },
    takeOrder: function takeOrder(order) {
      var _this2 = this;

      this.$dialog.loading.open("正在加载中");
      takeOrderHandle(order.order_id).then(function (res) {
        if (res.data.gain_integral != "0.00" && res.data.gain_coupon != "0.00" || res.data.gain_integral > 0 && res.data.gain_coupon > 0) {
          _this2.$dialog.loading.close();

          _this2.generalActive = true;
          _this2.generalContent = {
            promoterNum: "\u606D\u559C\u60A8\u83B7\u5F97".concat(res.data.gain_coupon, "\u5143\u4F18\u60E0\u5238\u4EE5\u53CA").concat(res.data.gain_integral, "\u79EF\u5206\uFF0C\u8D2D\u4E70\u5546\u54C1\u65F6\u53EF\u62B5\u73B0\u54E6\uFF5E"),
            title: "恭喜您获得优惠礼包"
          };
          return;
        } else if (res.data.gain_integral != "0.00" || res.data.gain_integral > 0) {
          _this2.$dialog.loading.close();

          _this2.generalActive = true;
          _this2.generalContent = {
            promoterNum: "\u606D\u559C\u60A8\u83B7\u5F97".concat(res.data.gain_integral, "\u79EF\u5206\uFF0C\u8D2D\u4E70\u5546\u54C1\u65F6\u53EF\u62B5\u73B0\u54E6\uFF5E"),
            title: "赠送积分"
          };
          return;
        } else if (res.data.gain_coupon != "0.00" || res.data.gain_coupon > 0) {
          _this2.$dialog.loading.close();

          _this2.generalActive = true;
          _this2.generalContent = {
            promoterNum: "\u606D\u559C\u60A8\u83B7\u5F97".concat(res.data.gain_coupon, "\u5143\u4F18\u60E0\u5238\uFF0C\u8D2D\u4E70\u5546\u54C1\u65F6\u53EF\u62B5\u73B0\u54E6\uFF5E"),
            title: "恭喜您获得优惠券"
          };
          return;
        } else {
          _this2.$dialog.loading.close();

          _this2.$dialog.success("收货成功");
        }

        _this2.getOrderData();

        _this2.orderList = [];
        _this2.page = 1;
        _this2.loaded = false;
        _this2.loading = false;

        _this2.getOrderList();
      }).catch(function (err) {
        _this2.$dialog.loading.close();

        _this2.$dialog.error(err.msg);
      });
    },
    closeGeneralWindow: function closeGeneralWindow(msg) {
      this.generalActive = msg;
      this.reload();
      this.getOrderData();
    },
    reload: function reload() {
      this.changeType(this.type);
    },
    changeType: function changeType(type) {
      this.type = type;
      this.orderList = [];
      this.page = 1;
      this.loaded = false;
      this.loading = false;
      this.getOrderList();
    },
    getOrderList: function getOrderList() {
      var _this3 = this;

      if (this.loading || this.loaded) return;
      this.loading = true;
      var page = this.page,
          limit = this.limit,
          type = this.type;

      _getOrderList({
        page: page,
        limit: limit,
        type: type
      }).then(function (res) {
        _this3.orderList = _this3.orderList.concat(res.data);
        _this3.page++;
        _this3.loaded = res.data.length < _this3.limit;
        _this3.loading = false;
      });
    },
    getStatus: function getStatus(order) {
      return STATUS[order._status._type];
    },
    cancelOrder: function cancelOrder(order) {
      var _this4 = this;

      cancelOrderHandle(order.order_id).then(function () {
        _this4.getOrderData();

        _this4.orderList.splice(_this4.orderList.indexOf(order), 1);
      }).catch(function () {
        _this4.reload();
      });
    },
    paymentTap: function paymentTap(order) {
      var _this5 = this;

      var that = this;

      if (!(order.combination_id > 0 || order.bargain_id > 0 || order.seckill_id > 0)) {
        that.setOfflinePayStatus(order.offlinePayStatus);
      }

      this.pay = true;

      this.toPay = function (type) {
        payOrderHandle(order.order_id, type, that.from).then(function () {
          var type = parseInt(_this5.$route.params.type) || 0;
          that.changeType(type);
          that.getOrderData();
        }).catch(function (res) {
          if (res.status === "WECHAT_H5_PAY") return that.$router.push({
            path: "/order/status/" + order.order_id + "/5"
          });
          var type = parseInt(that.$route.params.type) || 0;
          that.changeType(type);
          that.getOrderData();
        });
      };
    },
    toPay: function toPay() {}
  },
  mounted: function mounted() {
    var _this6 = this;

    this.getOrderData();
    this.getOrderList();
    this.$scroll(this.$refs.container, function () {
      !_this6.loading && _this6.getOrderList();
    });
  }
};